module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/sophie-spinale-239313ab155994cefa3266c508f71339.jpg";